import { NETWORK_ONLINE, NETWORK_OFFLINE } from './actionTypes';

// login request
const networkOnline = () => ({
  type: NETWORK_ONLINE,
});

const networkOffline = () => ({
  type: NETWORK_OFFLINE,
});

export { networkOnline, networkOffline };



// WEBPACK FOOTER //
// ./src/actions/network.js